<template>
  <div>
    <div id="dt_g" class="dataRow">
      <span v-for="index in dataRow.dt_g.length-endCol" :key="index"> <!-- need to draw upto endCol(column from right that will  not display) -->
        <numberinput v-model.number="dataRow.dt_g[index-1]" 
          :disabled="!!dataDisable[index-1]"
          @keypress="isNumber($event)" v-bind:class="disClass(!!dataDisable[index-1])"
        >
        </numberinput>
      </span>
      <span>
        <input v-model="rg" :disabled="true" class="totalBox">
      </span>
      <span>
        <numberinput v-model="dataRow.dt_g[dataRow.dt_g.length-1]" class="inputBox"></numberinput>
      </span>
    </div>
    <div id="dt_b" class="dataRow">
      <span v-for="index in dataRow.dt_b.length-endCol" :key="index">
        <numberinput v-model.number="dataRow.dt_b[index-1]" 
          :disabled="!!dataDisable[index-1]"
          @keypress="isNumber($event)" v-bind:class="disClass(!!dataDisable[index-1])"
        >
        </numberinput>
      </span>
      <span>
        <input v-model="rb" :disabled="true" class="totalBox">
      </span>
      <span>
        <numberinput v-model="dataRow.dt_b[dataRow.dt_g.length-1]" class="inputBox"></numberinput>
      </span>
    </div>
  </div>
</template>

<script>

import NumberInput from '@/components/common/NumberInput.vue'

export default {
  name: 'scorebySubject',
  props: ['dataRow', 'dataDisable', 'endCol', 'colWidth', 'rowHeight'],
  components: {
    'numberinput': NumberInput
  },
  computed: {
    rg: function () {
      let l = this.dataRow.dt_g.length - this.endCol
      let sum = this.dataRow.dt_g.reduce(function (acc, cval, ind, arr) {
        return (ind <= l - 1) ? acc + Number(cval) : acc // l - 1 for sum 1-->11 only, 12 is Total
      }, 0)
      this.dataRow.dt_g[l] = sum
      return sum
    },
    rb: function () {
      let l = this.dataRow.dt_b.length - this.endCol
      let sum = this.dataRow.dt_b.reduce(function (acc, cval, ind, arr) {
        return (ind <= l - 1) ? acc + Number(cval) : acc // l - 1 for sum 1-->11 only, 12 is Total
      }, 0)
      this.dataRow.dt_b[l] = sum
      return sum
    }
  },
  methods: {
    isNumber: function (event) {
      var charCode = event.keyCode
      if (charCode < 48 || charCode > 57) {
        event.preventDefault()
      } else {
        return true
      }
    },
    disClass: function (arg) {
      return arg ? 'inputBoxDisable' : 'inputBox'
    }
  }
}
</script>

<style scoped>
div {
  font-size: 0px;
}
span {
  display: inline;
  font-size: 14px;
}
.dataRow {
  display: flex;
  width: 100%;
}
.inputBox {
  border:1px solid #000;
  text-align:center;
  width:50px;
  height: 30px;
}
.inputBoxDisable {
  border:1px solid #000;
  background: lightgray;
  color: lightgray;
  user-select: none;
  width:50px;
  height: 30px;
}
.totalBox {
  border:1px solid #000;
  background: lightgray;
  text-align: center;
  width: 60px;
  height: 30px;
}
</style>
